export const exitSlipDayShape =
  'tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-font-atkinson tw-transition-[background] tw-duration-[140ms] tw-ease-out';

export const exitSlipDateText = {
  size: 'tw-text-sm tw-font-normal tw-leading-5',
  selected: 'tw-text-neutral-0',
  moved: 'tw-text-indigo-600',
  muted: 'tw-text-neutral-500',
  default: 'tw-text-neutral-950',
};

export const exitSlipTagText = {
  size: 'tw-text-[10px] tw-font-bold tw-leading-3',
  selected: 'tw-text-indigo-50',
  todayLabel: 'tw-text-neutral-700',
  past: 'tw-text-neutral-400',
  canceled: 'tw-text-neutral-600',
  default: 'tw-text-indigo-600',
};

//Always rendered, even with nothing in it: the day cell centres its column, so a date with no
//subtitle would sit lower than its neighbours. Reserving the band keeps every date on one line.
export const exitSlipTagSlot = 'tw-flex tw-h-3 tw-shrink-0 tw-items-center tw-justify-center';

//A canceled ticket replaces the lesson number with a dot, so the day reads as "something was
//here" without implying it ran. bg-current keeps it in step with the tag colour.
export const exitSlipCanceledDot = 'tw-block tw-size-1 tw-shrink-0 tw-rounded-full !tw-bg-current';

//Plain utilities, never !important: the grid has no competing CSS, and forcing a resting
//background would out-rank `active:tw-bg-white` and swallow the pressed state.
export const exitSlipDayBox = {
  empty: 'tw-border-none tw-bg-transparent',
  selected: 'tw-border-none tw-bg-indigo-600',
  moved: 'tw-border-none tw-bg-indigo-50',
  today: 'tw-border-2 tw-border-solid tw-border-stone-100 tw-bg-stone-0',
  //applied from hover state held in JS, so the grid can suppress it on a disabled day
  hovered: 'tw-border-2 tw-border-solid tw-border-indigo-200 tw-bg-indigo-50',
};

export const exitSlipDayHome = 'tw-border-2 tw-border-solid tw-border-[#2E9079] tw-bg-stone-0';
